export default function add(...numbers: number[]) {
  return numbers.reduce((sum, n) => sum + n, 0);
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    add: typeof add;
  }
}
